import { atom, useAtom } from 'jotai';
import { persistedAtom } from '../utils/persistedAtom';
import * as zod from 'zod';
import { VesselReservationType } from '../../graphql';

const focusedOrders = atom<number[] | null>(null);
export const useFocusedOrders = () => useAtom(focusedOrders);

const vesselReservationDefaultTypeAtom = persistedAtom({
  schema: zod.nativeEnum(VesselReservationType),
  key: 'vessel_reservation_default_type',
  defaultValue: VesselReservationType.NEGOTIATING,
  getOnInit: true,
});

export const useVesselReservationDefaultType = () =>
  useAtom(vesselReservationDefaultTypeAtom);
